import { useMutation } from '@tanstack/react-query';
import { updateNotificationsViewedStatus } from 'config/requests/notifications';

type UseChangeViewedStatusProps = {
  onError?: (error: any) => void;
  onSuccess?: () => void;
};

type UseChangeViewedStatusReturnValue = {
  changeViewedStatus: (ids: string[]) => void;
};

export function useChangeViewedStatus({
  onSuccess,
  onError,
}: UseChangeViewedStatusProps): UseChangeViewedStatusReturnValue {
  const { mutate: changeViewedStatus } = useMutation({
    mutationKey: ['notificationIsViewed'],
    mutationFn: (ids: string[]) => updateNotificationsViewedStatus(ids),
    retry: false,
    onSuccess,
    onError,
  });

  return { changeViewedStatus };
}
